import LoginPage from './LogIn.vue';
export const routes = [
    {
        path: '/login',
        component: LoginPage,
        name: 'login.index',
    },
];
